import React from 'react';
import { motion } from 'framer-motion';
export function ProductPreview() {
  return <section className="py-20 px-4 bg-lightgreen overflow-hidden" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-246">
            Mirá lo que vas a recibir
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto rounded-full" data-id="element-247"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-12" data-id="element-248">
          {/* Mockup 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 40,
          rotate: -5
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: -5
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05,
          rotate: 0,
          zIndex: 10
        }} transition={{
          duration: 0.5
        }} className="w-64 aspect-[3/4] bg-white rounded-xl shadow-xl border border-gray-100 p-1 flex flex-col relative overflow-hidden" data-id="element-249">
            <img src="https://cdn.magicpatterns.com/uploads/uexpcpqgbNQ1vMmkoz8Pth/Metodo_simple_para_armar_un_plato_balanceado.png" alt="Método simple para armar un plato" className="w-full h-full object-contain rounded-lg" data-id="element-250" />
            <div className="absolute bottom-0 left-0 right-0 h-2 bg-primary" data-id="element-251"></div>
          </motion.div>

          {/* Mockup 2 (Center, slightly larger) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05,
          zIndex: 10
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-72 aspect-[3/4] bg-white rounded-xl shadow-2xl border border-gray-100 p-1 flex flex-col relative overflow-hidden z-10" data-id="element-252">
            <img src="https://cdn.magicpatterns.com/uploads/9mBoP1H3KoYKqCckGbqF2j/Como-calcular-la-cantidad-de-comida_(1).png" alt="Cómo calcular la cantidad de comida" className="w-full h-full object-contain rounded-lg" data-id="element-253" />
            <div className="absolute top-0 right-0 w-16 h-16 bg-accent/10 rounded-bl-full" data-id="element-254"></div>
          </motion.div>

          {/* Mockup 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 40,
          rotate: 5
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: 5
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05,
          rotate: 0,
          zIndex: 10
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="w-64 aspect-[3/4] bg-white rounded-xl shadow-xl border border-gray-100 p-1 flex flex-col relative overflow-hidden" data-id="element-255">
            <img src="https://cdn.magicpatterns.com/uploads/vH5nby14XYCRzr4YsM9kb1/Receta-3-Heladitos-Naturales-para-Perros.png" alt="Heladitos naturales para perros" className="w-full h-full object-contain rounded-lg" data-id="element-256" />
            <div className="absolute bottom-0 left-0 right-0 h-2 bg-accent" data-id="element-257"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}